import PropTypes from "prop-types";
import "../styles/QuotesSalesProgressBox.css";
import MoneyBag from "../images/MoneyBag.svg";

const QuotesSalesProgressBox = ({ promotionType, progress, cap }) => {
  const promotionConfig = {
    Quotes: {
      singular: "quote",
      plural: "quotes",
      action: "quoted",
    },
    Policies: {
      singular: "policy",
      plural: "policies",
      action: "sold",
    },
  };

  const config = promotionConfig[promotionType] || promotionConfig.Policies;
  const itemText = cap === 1 ? config.singular : config.plural;
  const action = config.action;

  return (
    <div className="quotes-sales-progress-box">
      <img
        src={MoneyBag}
        alt="Money Bag"
        className="quotes-sales-progress-icon"
      />
      <p className="quotes-sales-progress-text">
        You have {action}{" "}
        <span className="quotes-sales-progress-text green">{progress}</span> out
        of <strong>{cap}</strong> {itemText}.
      </p>
    </div>
  );
};

QuotesSalesProgressBox.propTypes = {
  promotionType: PropTypes.string.isRequired,
  progress: PropTypes.number.isRequired,
  cap: PropTypes.number.isRequired,
};

export default QuotesSalesProgressBox;
